import clsx from 'clsx';
import React from 'react';

import { ProButton } from '@components/Button/variants';
import LazyImgixImage from '@components/LazyImgixImage';
import { useEventTracking } from '@hooks';
import { ClickTarget, TrackingLocation, click } from '@tracking';

import { ProPerkWithButtonProps } from './interfaces';

const ProPerkWithButton = ({
  buttonText,
  className,
  description,
  link,
  logoUrl,
  title,
}: ProPerkWithButtonProps) => {
  const { trackEvent } = useEventTracking({
    location: TrackingLocation.ProInsights,
  });

  const handleClickTracking = () => {
    trackEvent(click({ clickTarget: ClickTarget.Subscribe, clickText: buttonText }));
  };

  return (
    <div
      className={clsx(
        'mt-24 flex flex-col items-center md:flex-row md:items-start md:justify-between md:gap-x-32',
        className
      )}
    >
      <LazyImgixImage
        alt={title}
        className="!flex w-full"
        src={logoUrl}
        wrapperClassName="block sm:max-w-[336px] md:max-w-[440px]"
      />
      <div className="mt-16 w-full sm:mt-24 md:mt-0">
        <h4 className="m-0 text-center font-suisse-works text-headline-xxs text-primary-black sm:text-headline-xs md:text-left">
          {title}
        </h4>
        <p className="m-0 mt-8 text-center font-suisse-intl text-body-lg text-primary-black sm:text-body-lg md:text-left">
          {description}
        </p>
        <ProButton
          as="link"
          className="mx-auto mt-16 md:mx-0"
          href={link}
          onClickCapture={handleClickTracking}
        >
          {buttonText}
        </ProButton>
      </div>
    </div>
  );
};

export default ProPerkWithButton;
